import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowRight } from 'lucide-react';
import { useLanguage } from '@/contexts/LanguageContext';
import AnimateOnScroll from '@/components/common/AnimateOnScroll';

const CallToAction = () => {
  const { isRTL } = useLanguage();

  return (
    <section className="section" dir={isRTL ? 'rtl' : 'ltr'}>
      <div className="container">
        <AnimateOnScroll>
          <div className="relative overflow-hidden rounded-2xl bg-hero-gradient dark:bg-hero-gradient-dark px-8 py-14 md:px-16 md:py-20">
            <div className="absolute inset-0 star-pattern-overlay opacity-50" />
            <div className="absolute -end-20 -top-20 w-[300px] h-[300px] rounded-full bg-amber-400/10 blur-[80px]" />

            <div className="relative z-10 max-w-2xl mx-auto text-center">
              <p className="font-arabic text-amber-400/60 text-2xl mb-4" dir="rtl">
                بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ
              </p>
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
                {isRTL ? 'ابدأ رحلتك مع القرآن اليوم' : 'Begin Your Quran Journey Today'}
              </h2>
              <p className="text-emerald-100/80 text-lg mb-8 max-w-lg mx-auto">
                {isRTL
                  ? 'انضم إلى آلاف الطلاب حول العالم الذين يتعلمون القرآن مع معلمين مؤهلين'
                  : 'Join thousands of students worldwide learning Quran with qualified, Ijazah-certified teachers'}
              </p>
              <div className="flex flex-col sm:flex-row gap-3 justify-center">
                <Button
                  asChild
                  size="lg"
                  className="bg-amber-500 hover:bg-amber-500/90 text-amber-950 font-semibold rounded-xl px-8 h-12"
                >
                  <Link to="/register" className="flex items-center gap-2">
                    {isRTL ? 'سجّل مجانًا' : 'Register Free'}
                    <ArrowRight className="h-4 w-4 rtl-mirror" />
                  </Link>
                </Button>
                <Button
                  asChild
                  size="lg"
                  className="bg-transparent border border-white/30 text-white hover:bg-white/10 rounded-xl px-8 h-12"
                >
                  <Link to="/teachers">
                    {isRTL ? 'تصفح المعلمين' : 'Browse Teachers'}
                  </Link>
                </Button>
              </div>
            </div>
          </div>
        </AnimateOnScroll>
      </div>
    </section>
  );
};

export default CallToAction;
